/* eslint-disable camelcase */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-unused-vars */
import { Tooltip, Menu, Dropdown, Divider, Checkbox, Input, Form, Spin } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import paypal from '../../../assets/images/paypal.svg';
import bank from '../../../assets/images/bank.svg';
import settingsloader from '../../../assets/images/settings.svg';
import skrill from '../../../assets/images/skrill.svg';
import wirecard from '../../../assets/images/wirecard.svg';
import DokanTextInputField from '../../../components/form/DokanTextInputField';
import DokanIcons from '../../../components/icon/DokanIcons';
import DokanModal from '../../../components/modal/DokanModal';
import DokanNotice from '../../../components/notice/DokanNotice';
import DokanPageSubtitle from '../../../components/text/DokanPageSubtitle';
import DokanPageTitle from '../../../components/text/DokanPageTitle';
import DokanSettingsFieldLabel from '../../../components/text/DokanSettingsFieldLabel';
import DokanPaymentCard from '../../../components/card/DokanPaymentCard';
import {
    fetchSettings,
    handlePaymentInputs,
    updatePaymentMethod,
} from '../../../redux/settings/settingsActions';
import DokanAlert from '../../../components/shared/Alert';

const { TextArea } = Input;
const Payments = () => {
    const loading = <img src={settingsloader} alt={settingsloader} className="h-6 w-6 opacity-1" />;
    const [visible, setVisible] = useState(false);
    const menu = (
        <Menu>
            <Menu.Item onClick={() => setVisible(true)}>Edit</Menu.Item>
            <Menu.Item onClick={() => ''}>Make Default</Menu.Item>
        </Menu>
    );
    const dispatch = useDispatch();
    const { settings, payment_loader } = useSelector((state) => state.settings);
    useEffect(() => {
        dispatch(fetchSettings());
    }, [dispatch]);
    const handlePaymentInput = (name, value, section) => {
        dispatch(handlePaymentInputs({ name, value, section }));
    };

    return (
        <>
            <div className="container mx-auto md:px-85px px-6">
                <div className="flex justify-between flex-col gap-5 md:flex-row pt-35px">
                    <div>
                        <DokanPageTitle>Payment</DokanPageTitle>
                    </div>
                </div>
                <DokanPageSubtitle>
                    These are the withdraw methods available for you. Please update your payment
                    information below to submit withdraw requests and get your store payments
                    seamlessly.
                </DokanPageSubtitle>
                <DokanModal visible={visible} setVisible={setVisible} />
                <DokanPaymentCard
                    hasTitle
                    Title="Payment Methods"
                    hasBtn
                    btnTitle="Add Payment Method"
                >
                    <div className="px-25px py-20px hover:bg-ash-one flex pl-2 items-center">
                        <div className="bg-white rounded-full w-11 h-11 p-3 shadow-dokan">
                            <img
                                src={wirecard}
                                alt={wirecard}
                                className="h-full w-full rounded-full"
                            />
                        </div>
                        <div className="pl-5 flex-grow-4">
                            <div className="flex items-center gap-3">
                                <div className="font-bold">WireCard</div>
                                <Tooltip placement="top" title="Default">
                                    <div>
                                        <DokanIcons icon="#checked_ok" />
                                    </div>
                                </Tooltip>
                            </div>
                            <div className="text-tertiary font-light">abc@gmail.com</div>
                        </div>
                        <div className="opacity-25 hover:opacity-100">
                            <Dropdown overlay={menu} trigger={['click']} arrow>
                                <button
                                    type="button"
                                    className="ant-dropdown-link"
                                    onClick={(e) => e.preventDefault()}
                                >
                                    <DokanIcons icon="#more" />
                                </button>
                            </Dropdown>
                        </div>
                    </div>
                    <div className="px-25px py-20px hover:bg-ash-one flex pl-2 items-center">
                        <div className="bg-white rounded-full w-11 h-11 p-3 shadow-dokan">
                            <img src={skrill} alt={skrill} className="h-full w-full rounded-full" />
                        </div>
                        <div className="pl-5 flex-grow-4">
                            <div className="flex items-center gap-3">
                                <div className="font-bold">Stripe</div>
                                <Tooltip placement="top" title="Default">
                                    <div>
                                        <DokanIcons icon="#checked_ok" />
                                    </div>
                                </Tooltip>
                            </div>
                            <div className="text-tertiary font-light">abc@gmail.com</div>
                        </div>
                        <div className="opacity-25 hover:opacity-100">
                            <Dropdown overlay={menu} trigger={['click']} arrow>
                                <button
                                    type="button"
                                    className="ant-dropdown-link"
                                    onClick={(e) => e.preventDefault()}
                                >
                                    <DokanIcons icon="#more" />
                                </button>
                            </Dropdown>
                        </div>
                    </div>
                    <div>
                        <div className="block md:hidden">
                            <button
                                type="button"
                                className="bg-blue-payment text-white rounded-md px-20px py-10px focus:outline-none"
                            >
                                Add Payment Method
                            </button>
                        </div>
                    </div>
                </DokanPaymentCard>
                <DokanPaymentCard hasTitle Title="PayPal">
                    <div className="flex flex-grow-6 justify-start items-center gap-5">
                        <div className="flex-grow-5">
                            <div className="">
                                <div className="flex items-center ml-5">
                                    <div className="flex-grow-1 md:w-3/12 font-bold">
                                        <div className="flex items-center gap-5">
                                            <div>
                                                <div className="bg-white rounded-full w-11 h-11 p-3 shadow-dokan">
                                                    <img
                                                        src={skrill}
                                                        alt={skrill}
                                                        className="h-full w-full rounded-full"
                                                    />
                                                </div>
                                            </div>
                                            <div>Account Name</div>
                                        </div>
                                    </div>
                                    <div className="flex-grow-4 w-3/12">&nbsp;</div>
                                </div>
                                <div className="flex-grow-4 md:w-6/12 ml-20">
                                    <Input
                                        className="mt-2"
                                        placeholder="Account Name"
                                        value={settings?.payment?.bank?.ac_name}
                                        onChange={(e) => {}}
                                    />
                                </div>

                                <div className="">
                                    <div>
                                        <Checkbox className="pt-5 ml-20 text-tertiary">
                                            Make this default payment method
                                        </Checkbox>
                                    </div>
                                </div>

                                <div className="flex items-center justify-start ml-20 pt-8">
                                    <Spin
                                        spinning={payment_loader}
                                        indicator={loading}
                                        className=""
                                    >
                                        {/* <button
                                        type="button"
                                        className="m-2 py-3 px-4 bg-gray-light text-tertiary rounded-sm"
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        Cancel
                                    </button> */}
                                        <button
                                            type="button"
                                            className="py-3 px-4 bg-blue-payment hover:bg-blue-dodger text-white rounded-md focus:outline-none"
                                            onClick={(e) => {}}
                                        >
                                            Update Settings
                                        </button>
                                    </Spin>
                                </div>
                                <DokanAlert />
                            </div>
                        </div>
                    </div>
                </DokanPaymentCard>
                <DokanPaymentCard hasTitle Title="Bank Information" hasIcon Icon="#bank">
                    <div className="flex flex-grow-6 justify-start items-center gap-5">
                        <div className="flex-grow-5">
                            <div className="">
                                <div className="flex items-center">
                                    <div className="flex-grow-1 w-3/12 font-bold">Account Name</div>
                                    <div className="flex-grow-4 w-6/12">
                                        <Input
                                            className="mt-5"
                                            placeholder="Account Name"
                                            value={settings?.payment?.bank?.ac_name}
                                            onChange={(e) =>
                                                handlePaymentInput(
                                                    'acc_name',
                                                    e.target.value,
                                                    'bank'
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="flex-grow-4 w-3/12">&nbsp;</div>
                                </div>
                                <div className="flex items-center">
                                    <div className="flex-grow-1 w-3/12 font-bold">Account No.</div>
                                    <div className="flex-grow-4 w-6/12">
                                        <Input
                                            className="mt-5"
                                            placeholder="Account No."
                                            value={settings?.payment?.bank?.ac_number}
                                            onChange={(e) =>
                                                handlePaymentInput(
                                                    'acc_number',
                                                    e.target.value,
                                                    'bank'
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="flex-grow-4 w-3/12">&nbsp;</div>
                                </div>
                                <div className="flex items-center">
                                    <div className="flex-none w-3/12 font-bold">Name of Bank</div>
                                    <div className="flex-grow-2 w-6/12">
                                        <Input
                                            className="mt-5"
                                            placeholder="Name of Bank"
                                            value={settings?.payment?.bank?.bank_name}
                                            onChange={(e) =>
                                                handlePaymentInput(
                                                    'bank_name',
                                                    e.target.value,
                                                    'bank'
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="flex-grow-4 w-3/12">&nbsp;</div>
                                </div>
                                <div className="flex items-center">
                                    <div className="flex-grow-1 w-3/12 font-bold">Address</div>
                                    <div className="flex-grow-2 w-6/12">
                                        <TextArea
                                            className="mt-5"
                                            placeholder="Address"
                                            value={settings?.payment?.bank?.bank_addr}
                                            onChange={(e) =>
                                                handlePaymentInput(
                                                    'bank_addr',
                                                    e.target.value,
                                                    'bank'
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="flex-grow-4 w-3/12">&nbsp;</div>
                                </div>
                                <div className="flex items-center">
                                    <div className="flex-grow-1 w-3/12 font-bold">
                                        Routing Number
                                    </div>
                                    <div className="flex-grow-2 w-6/12">
                                        <Input
                                            className="mt-5"
                                            placeholder="Routing"
                                            value={settings?.payment?.bank?.routing_number}
                                            onChange={(e) =>
                                                handlePaymentInput(
                                                    'routing_number',
                                                    e.target.value,
                                                    'bank'
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="flex-grow-4 w-3/12">&nbsp;</div>
                                </div>
                                <div className="flex items-center">
                                    <div className="flex-grow-1 w-3/12 font-bold">IBAN</div>
                                    <div className="flex-grow-2 w-6/12">
                                        <Input
                                            className="mt-5"
                                            placeholder="IBAN"
                                            value={settings?.payment?.bank?.iban}
                                            onChange={(e) =>
                                                handlePaymentInput('iban', e.target.value, 'bank')
                                            }
                                        />
                                    </div>
                                    <div className="flex-grow-4 w-3/12">&nbsp;</div>
                                </div>
                                <div className="flex items-center">
                                    <div className="flex-grow-1 w-3/12 font-bold">Swift Code</div>
                                    <div className="flex-grow-2 w-6/12">
                                        <Input
                                            className="mt-5"
                                            placeholder="Swift Code"
                                            value={settings?.payment?.bank?.swift}
                                            onChange={(e) =>
                                                handlePaymentInput('swift', e.target.value, 'bank')
                                            }
                                        />
                                    </div>
                                    <div className="flex-grow-4 w-3/12">&nbsp;</div>
                                </div>
                                {/* <div className="">
                                    <div>
                                        <Checkbox className="pb-10 text-tertiary">
                                            I attest that I am the owner and have full authorization
                                            to this bank account.
                                        </Checkbox>
                                    </div>
                                    <div>
                                        <Checkbox className="pb-10 text-tertiary">
                                            Make this default payment method
                                        </Checkbox>
                                    </div>
                                </div> */}

                                <div className="flex items-center justify-center pt-8">
                                    <Spin
                                        spinning={payment_loader}
                                        indicator={loading}
                                        className=""
                                    >
                                        {/* <button
                                        type="button"
                                        className="m-2 py-3 px-4 bg-gray-light text-tertiary rounded-sm"
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        Cancel
                                    </button> */}
                                        <button
                                            type="button"
                                            className="m-2 py-3 px-4 bg-blue-payment hover:bg-blue-dodger text-white rounded-md focus:outline-none"
                                            onClick={(e) => dispatch(updatePaymentMethod(settings))}
                                        >
                                            Update Account
                                        </button>
                                    </Spin>
                                </div>
                                <DokanAlert />
                            </div>
                        </div>
                    </div>
                </DokanPaymentCard>
            </div>
        </>
    );
};

export default Payments;
